export default "__VITE_ASSET__juKRYzM3__";